// extracted by mini-css-extract-plugin
export default {"card":"c2-z"};